import { MediaView } from '@lemoncloud/codes-goods-api/dist/modules/medias/views';

import { webCore } from '@codes/web-core';

const FILE_ENDPOINT = import.meta.env.VITE_FILE_ENDPOINT;

export const uploadFile = async (body: FormData): Promise<MediaView> => {
    const extraHeader = {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'multipart/form-data',
    };

    const { data } = await webCore
        .buildSignedRequest({ method: 'POST', baseURL: `${FILE_ENDPOINT}/upload/file` })
        .setHeaders({ ...extraHeader })
        .setBody(body)
        .execute<MediaView>();

    return data;
};
